import {useCallback} from "react";
import {useNavigate, useParams} from "react-router-dom";

// Р2 — след успешен запис формата се затваря и страницата се връща най-горе.
//
// Причината: формите се отварят В КРАЯ на страницата (под таблиците за замени и
// изчертано) и екранът се сваля дотам. След запис оставаше долу, при все още
// „активен" бутон — изглеждаше, че операцията не е приключила. Сега връщането
// най-горе е самото потвърждение, че е готово.
//
// Затварянето е навигация към адреса на ползвателя БЕЗ подраздел — същото
// състояние, като че ли никой бутон не е избран.
export const useCloseForm = () => {
    const navigate = useNavigate();
    const {year, settlement_ekatte, bullstat} = useParams();

    return useCallback(() => {
        navigate(`/info/${year}/${settlement_ekatte}/${bullstat}`);
        window.scrollTo({top: 0, behavior: "smooth"});
    }, [navigate, year, settlement_ekatte, bullstat]);
};
